import Vue from "vue";
import { ValidationProvider, ValidationObserver } from "./validate.js";
import ActionCol from "@/components/ActionCol/ActionCol.vue";
import ActionColBtn from "@/components/ActionCol/ActionColBtn.vue";
import ActionColMenu from "@/components/ActionCol/ActionColMenu.vue";
import ActionColMenuItem from "@/components/ActionCol/ActionColMenuItem.vue";
import Card from "@/components/Card/Card.vue";
import CardTitle from "@/components/Card/CardTitle.vue";
import CardContent from "@/components/Card/CardContent.vue";
import CardActions from "@/components/Card/CardActions.vue";
import ReqLabel from "@/components/ReqLabel.vue";
import RouterSwitch from "@/components/RouterSwitch.vue";
import VueMask from "v-mask";

Vue.component("action-col", ActionCol);
Vue.component("action-col-btn", ActionColBtn);
Vue.component("action-col-menu", ActionColMenu);
Vue.component("action-col-menu-item", ActionColMenuItem);
Vue.component("card", Card);
Vue.component("card-title", CardTitle);
Vue.component("card-content", CardContent);
Vue.component("card-actions", CardActions);
Vue.component("req-label", ReqLabel);
Vue.component("router-switch", RouterSwitch);

Vue.component("validation-provider", ValidationProvider);
Vue.component("validation-observer", ValidationObserver);

Vue.use(VueMask);
